import { gql } from "@apollo/client";

const EDIT_FINAL_TABLE = gql`
  mutation editFinalTable($tableID: String, $tableType: String!, $autoRecoValue: Boolean, $reason: String) {
    editFinalTable(tableID: $tableID, tableType: $tableType, autoRecoValue: $autoRecoValue, reason: $reason) 
  }
`;

export default EDIT_FINAL_TABLE;
